export default __webpack_public_path__ + "static/media/repayment-channel-icon3.c077fc00.png";